import { Form, FormProps, Input, Modal, ModalProps } from '@pankod/refine-antd'
import React from 'react'

type TagModalFormProps = {
  formProps: FormProps
  modalProps: ModalProps
  type: 'create' | 'edit'
  onClose: () => void
}

const TagModalForm = ({
  formProps,
  modalProps,
  type,
  onClose,
}: TagModalFormProps) => {
  const title = type === 'create' ? 'Buat Tag' : 'Ubah Tag'
  return (
    <Modal
      {...modalProps}
      title={title}
      onCancel={onClose}
      cancelText="Batal"
      okText="Simpan"
      width={400}
    >
      <Form {...formProps} layout="vertical">
        {type === 'create' && (
          <Form.Item
            label="Kode"
            name="code"
            required
            rules={[{ required: true, message: 'Kode harus diisi.' }]}
          >
            <Input autoComplete="off" />
          </Form.Item>
        )}
        <Form.Item
          label="Nama"
          name="name"
          required
          rules={[{ required: true, message: 'Nama harus diisi.' }]}
        >
          <Input autoComplete="off" />
        </Form.Item>
      </Form>
    </Modal>
  )
}

export default TagModalForm
